import { WatchlistBaseModel, WatchlistEntityRequest, WatchlistGeneralRequest, WatchlistIndividualRequest } from './WatchlistDomains';

export interface WatchlistAlertDomains {
  id: string;
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest;
  status: AlertStatus;
  score: number;
  results: WatchlistBaseModel[];
  metadata: {
    assignee: string;
    reason?: string;
  };
  createdAt: number;
  updatedAt?: number;
}

export enum AlertStatus {
  WAITING_FOR_REVIEW = 'WAITING_FOR_REVIEW',
  IN_REVIEW = 'IN_REVIEW',
  NOT_MATCH = 'MARKED_AS_NOT_MATCHED',
  MATCH = 'MARKED_AS_MATCHED',
}

export interface AlertLog {
  id: string;
  type: 'COMMENT' | 'ASSIGNEE' | 'CLOSE';
  alertId: string;
  username: string;
  timestamp: number;
  ip: string;
}

export interface AlertCommentLog extends AlertLog {
  content: string;
}

export interface AlertAssigneeLog extends AlertLog {
  assignee: string;
}

export interface AlertCloseLog extends AlertLog {
  reason?: string;
}
